'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../components');

var _containers = require('../containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function (_Component) {
  (0, _inherits3.default)(Header, _Component);

  function Header(props) {
    (0, _classCallCheck3.default)(this, Header);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).call(this, props));

    _this.state = { showMobileMenu: false };
    return _this;
  }

  (0, _createClass3.default)(Header, [{
    key: 'showMobileMenu',
    value: function showMobileMenu() {
      this.setState({ showMobileMenu: !this.state.showMobileMenu });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'header',
        { className: 'Header' },
        _react2.default.createElement(
          'div',
          { className: 'main' },
          _react2.default.createElement(
            'div',
            { className: 'responsive-container' },
            _react2.default.createElement(
              'div',
              { className: 'logo' },
              _react2.default.createElement(
                'a',
                { href: 'https://uqam.ca' },
                _react2.default.createElement('img', { src: '/images/logo-uqam.svg', alt: _config2.default.app.title })
              ),
              _react2.default.createElement(_components.QuickLinks, null)
            ),
            _react2.default.createElement(
              'div',
              { className: 'title', onClick: this.showMobileMenu.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'Calendrier des \xE9v\xE9nements'
              )
            ),
            _react2.default.createElement(_containers.SearchBarContainer, null)
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'breadcrumbs' },
          _react2.default.createElement(
            'div',
            { className: 'responsive-container' },
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { href: 'https://uqam.ca' },
                  'UQAM'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                'Calendrier des \xE9v\xE9nements'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'responsive-container' },
          _react2.default.createElement(_components.Menu, { showMobile: this.state.showMobileMenu, showMobileAction: this.showMobileMenu.bind(this) })
        )
      );
    }
  }]);
  return Header;
}(_react.Component);

exports.default = Header;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header.js
// module id = 1116
// module chunks = 0